<template>
  <div class="p-1">
    <!-- <b-button @click="showModal" size="sm" variant="outline-dark" block>{{t(name)}}</b-button>
    <b-modal @close="closedModal" :ok-title="t('calculate')" :cancel-title="t('close')" @cancel="closedModal" @ok="calculate" no-close-on-esc no-close-on-backdrop :title="t('calculateReceivingFees')" id="check-fees" centered>
      <div>
        <div v-if="response.currencyCode" class="fees-response alert alert-dark p-1 text-dark">
          <div>{{t('amount')}}: {{formatCurrency(response.amount, response.currencyCode)}} <small>{{response.currencyCode}}</small></div>
          <div>{{t('payerFee')}}: {{formatCurrency(response.payerFee, response.currencyCode)}} <small>{{response.currencyCode}}</small></div>
          <div>{{t('merchantFee')}}: {{formatCurrency(response.merchantFee, response.currencyCode)}} <small>{{response.currencyCode}}</small></div>
          <div>{{t('totalFee')}}: {{formatCurrency(response.totalFee, response.currencyCode)}} <small>{{response.currencyCode}}</small></div>
          <div>{{t('youReceive')}}: {{formatCurrency(response.merchantReceivesAmount, response.currencyCode)}} <small>{{response.currencyCode}}</small></div>
        </div>
        <label for="">{{t('chooseCurrency')}} <span class="text-danger">*</span></label>
        <v-select v-model="currency" :options="currencies" :get-option-label="(option) => option.name" :get-option-value="(option) => option.name" :clearable="false">
          <template #no-options>
            <div>
              {{ t('sorryNoMatchingOptions') }}
            </div>
          </template>
        </v-select>
        <label class="d-block mt-1" for="">{{t('whoPaysFee')}}?</label>
        <v-select v-model="feePayer" @option:selected="submit=true" :options="feePayers"
          :get-option-label="(option) => t(option.label)" :clearable="false"
        >
          <template #no-options>
            <div>
              {{ t('sorryNoMatchingOptions') }}
            </div>
          </template>
        </v-select>


        <small class="d-block mt-1">{{ t('amount') }} <span class="text-danger">*</span></small>
        <b-input ref="amount" :autofocus="true" v-model="amount" type="number" autocomplete="off"></b-input>
        <small class="d-block pt-1">{{ t('paymentMethod') }} <span class="text-danger">*</span> </small>
        <v-select ref="destination" v-model="type" :options="types" :clearable="false">
          <template #option="data">
            <div class="">
              <div class="pl-1">
                {{ data.label }}
              </div>
            </div>
          </template>
          <template #no-options>
            <div>
              {{ t('sorryNoMatchingOptions') }}
            </div>
          </template>
        </v-select>
      </div>
    </b-modal>-->
  </div>
</template>
<script>

import vSelect from 'vue-select'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import API from './api';
import utils from '@/utils';

export default {
  name: 'CalculateFee',
  components: {
    vSelect
  },
  props: {
    name: {
      type: String,
      default: 'calculateFee'
    }
  },
  data() {
    return {
      formatCurrency: utils.formatCurrency,
      response: {

      },
      amount: '',
      feePayers: [
        { label: 'defaultSettings', value: null },
        { label: 'merchant', value: 1 },
        { label: 'payer', value: 2 },
        { label: 'evenSplit', value: 3 },
      ],
      types: [],
      currencies: [],
      type: '',
      feePayer: '',
      currency: '',
    }
  },
  watch: {
    type(data){
      if(data && this.amount){
        this.calculate();
      }
    },
    currency(data){
      if(data && this.amount){
        this.calculate();
      }
    },
    feePayer(data){
      if(data && this.amount){
        this.calculate();
      }
    },
  },
  mounted() {
    this.feePayer = this.feePayers[0];
    this.getTypes();
    this.getCurrencies();
  },
  methods: {
    getCurrencies() {
      API.getCurrencies().then(res => {
        if (res.success && res.data) {
          this.currencies = res.data.map(e => {
            return { name: e }
          })
          const currency= this.currencies.filter(e=> e.name == 'XAF');
          this.currency = currency.length ? currency[0] : this.currencies[0];
        }
      }).catch(error => {
        console.log(error);
      })
    },
    calculate(e) {
      if(e) e.preventDefault();
      if(!this.amount || !this.currency || !this.type){
        this.showToast(this.$t('pleaseFillAllRequiredFields'));
        return;
      }
      const param = {
        amount: this.amount,
        currencyCode: this.currency.name,
        feePayer: this.feePayer.value,
        payerAccountType: this.type.value
      }
      this.response = {};
      API.calculate(param).then(res => {
        if (res.success && res.data) {
          this.response = res.data;
        }
      }).catch(err=>{
        console.log(err);
        this.showToast(this.$t('operationFailed'));
      })
    },
    getTypes() {
      API.getTypes().then(res => {
        if (res.success && res.data) {
          this.types = Object.keys(res.data).map(item => {
            const type = { value: item, label: res.data[item] };
            return type;
          });

          if (this.types.length) this.type = this.types[0];

        }
      }).catch(err => {
        console.log(err);
      })
    },
    showModal() {
      this.$bvModal.show("check-fees");
    },
    closedModal(e) {
      this.$emit('fee-check-closed')
    },
    checkFees(e) {
      console.log('modal just closed');
    },
    showToast(message, variant = 'danger', title = null) {
      this.$bvToast.toast(`${message}`, {
        title: title || this.$t('error'),
        autoHideDelay: 5000,
        appendToast: true,
        solid: true,
        variant: variant
      })
    },
  },
  setup(props) {

    const { t } = useI18nUtils()
    return {
      t
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>